var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignature(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 209.247,
    height: 148.844,
    viewBox: "0 0 209.247 148.844",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 209.247,
    height: 148.844,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.461,227.924a43.187,43.187,0,0,1,3.2-9.709A221.178,221.178,0,0,1,321,151.639a90.465,90.465,0,0,1,14.339-12.468c1.037,2.706.281,5.747-.543,8.527-11.007,37.1-32.873,69.865-46.552,106.03",
    transform: "translate(-272.963 -128.323)",
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 1.011
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.456,229.568a2.077,2.077,0,0,1-2.148-.237q20.239-15.5,41.457-29.614",
    transform: "translate(-272.963 -128.323)",
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 1.011
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.794,217.1l2.936-4.374a47.69,47.69,0,0,0-6.567,15.066c6.338-5.254,10.249-13.131,16.816-18.085q-1.982,5.354-3.516,10.867a28.409,28.409,0,0,0,5.649-6.08,10.308,10.308,0,0,0,.015,4.6l6.743-8.126a5.817,5.817,0,0,0,.227,4.358,11.884,11.884,0,0,0,5.161-5.984,12.732,12.732,0,0,0-5.312,7.012,1.159,1.159,0,0,0-.009.907c.272.468.965.339,1.457.125a17.7,17.7,0,0,0,6.511-4.864,8.641,8.641,0,0,0-1.312,3.9c1.219,1.064,3.058.018,4.3-1.015l9.28-7.7-.676,1.628",
    transform: "translate(-272.963 -128.323)",
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 1.011
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.779,163.518A296.875,296.875,0,0,0,409.9,131.435c-8.225,42.926-39.705,77.992-49.913,120.476",
    transform: "translate(-272.963 -128.323)",
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 1.011
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.277,199.6c1.9-5.884,5.611-10.956,9.261-15.913,4.65-6.316,9.3-12.631,14.057-18.865,3.127-4.1,6.408-8.26,10.821-10.859,1.12-.66,2.782-1.1,3.517-.015a2.788,2.788,0,0,1,.281,1.79c-.589,7.642-3.873,14.78-7.432,21.535A231.814,231.814,0,0,1,389.715,202c-4.732,6.771-9.954,13.4-16.81,17.911-.459-1.034.256-2.19.945-3.084a177.067,177.067,0,0,1,18.111-20.134,57.4,57.4,0,0,0-2.806,12.631,105.743,105.743,0,0,0,13.994-19.777,18.091,18.091,0,0,0-4.9,11.837,17.058,17.058,0,0,0,8.445-11.166,26.173,26.173,0,0,0-5.11,5.911c-.393.622-.763,1.434-.38,2.063.5.816,1.724.545,2.559.1a15.656,15.656,0,0,0,6.484-6.629,13.214,13.214,0,0,0-1.274,9.092,8.434,8.434,0,0,0,4.548-7.318,5.435,5.435,0,0,0-2.171,5.11,513.109,513.109,0,0,0,33.723-59.405c-4.26,3.492-6.995,8.512-9.518,13.453q-5.655,11.074-10.607,22.5c-4.011,9.258-7.723,18.925-7.983,29.039-.032,1.238.387,2.9,1.6,2.869a2.238,2.238,0,0,0,1.373-.767,27.677,27.677,0,0,0,7.527-12.593c-.105,1.263-.828,2.385-1.089,3.624s.239,2.863,1.474,3.019a2.945,2.945,0,0,0,2.016-.833c1.9-1.44,3.968-4.139,2.352-5.9a10.646,10.646,0,0,0-4.141,5.013c-.448,1.122-.512,2.746.59,3.2.794.331,1.663-.2,2.355-.72a129.011,129.011,0,0,0,11.345-9.514c-7.148,19.211-14.3,38.426-22.042,57.395a240,240,0,0,1-12.61,27.174c-.167.3-.437.64-.761.551s-.007-.753.162-.456",
    transform: "translate(-272.963 -128.323)",
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 1.011
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.691,261.062l16.693-6.692c10.9-4.369,21.8-8.738,32.838-12.72a498.411,498.411,0,0,1,117.884-26.91",
    transform: "translate(-272.963 -128.323)",
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 2.022
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.957,180.349a1.748,1.748,0,0,0,1.578-2.331,1.7,1.7,0,0,0-2.754-.388,3.406,3.406,0,0,0-.53,2.035",
    transform: "translate(-272.963 -128.323)",
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 1.011
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignature);
export default __webpack_public_path__ + "static/media/Signature.8f2a001d56e8f7d883e166ac3cc69892.svg";
export { ForwardRef as ReactComponent };